import { ColorTypeEnum, DayOfWeekEnum, RiderVehicleTypeEnum, RidesharingAppEnum, VehicleModel } from 'app/models';

export class AddOperatorVehicleModel {
    /*Vehicle Details*/
    VehicleTypeId: RiderVehicleTypeEnum = RiderVehicleTypeEnum.None;
    VehicleBrandId!: number;
    VehicleModelId?: VehicleModel | null;
    VehicleYear!: number;
    VehicleColor?: ColorTypeEnum | null;
    VehicleYearStr!: Date | string;
    NumberPlate!: string;
    RegistrationNumber!: string;
    IsOwner: boolean = true;
    /*End Vehicle Details*/

    /*Owner Details*/
    OwnerFirstName!: string;
    OwnerLastName!: string;
    OwnerEmail!: string;
    OwnerPhone!: string;
    /*End Owner Details*/

    /*Vehicle Photos*/
    VehicleFrontImageUrl!: string;
    VehicleFrontImageUrlFile!: File;
    VehicleFrontImageUrlIsLoading: boolean = false;

    VehicleBackImageUrl!: string;
    VehicleBackImageUrlFile!: File;
    VehicleBackImageUrlIsLoading: boolean = false;

    VehicleRightSideImageUrl!: string;
    VehicleRightSideImageUrlFile!: File;
    VehicleRightSideImageUrlIsLoading: boolean = false;

    VehicleLeftSideImageUrl!: string;
    VehicleLeftSideImageUrlFile!: File;
    VehicleLeftSideImageUrlIsLoading: boolean = false;
    /*End Vehicle Photos*/

    /*Vehicle Ownership*/
    LTOOfficialReceiptImageUrl!: string;
    LTOOfficialReceiptImageUrlFile!: File;
    LTOOfficialReceiptImageUrlIsLoading: boolean = false;
    LTOOfficialReceiptExpireAt!: Date;

    CertificateRegistrationImageUrl!: string;
    CertificateRegistrationImageUrlFile!: File;
    CertificateRegistrationImageUrlIsLoading: boolean = false;

    SPAImageUrl!: string;
    SPAImageUrlFile!: File;
    SPAImageUrlIsLoading: boolean = false;
    /*End Vehicle Ownership*/

    /*TNVC Document*/
    IsRegisteredTNC: boolean = false;
    TNCType!: RidesharingAppEnum;
    PaOrCpcCaseNumber!: string;

    ProvisionalAuthorityImageUrl!: string;
    ProvisionalAuthorityImageUrlFile!: File;
    ProvisionalAuthorityImageUrlIsLoading: boolean = false;
    ProvisionalAuthorityExpireAt!: Date;

    CertificatePublicConvenienceImageUrl!: string;
    CertificatePublicConvenienceImageUrlFile!: File;
    CertificatePublicConvenienceImageUrlIsLoading: boolean = false;
    CertificatePublicConvenienceExpireAt!: Date;
    /*End TNVC Document*/

    /*Boundary Fee*/
    BoundaryFeeAmount!: number;
    BoundaryProcessingFee: number = 10;
    BoundaryAvailableDays: DayOfWeekEnum[] = [];
    BoundaryAvailableFromHours!: number;
    BoundaryAvailableFromMins!: number;
    BoundaryAvailableToHours!: number;
    BoundaryAvailableToMins!: number;
    CollectAtStart!: boolean;
    TimeZoneOffset!: number;
    /*End Boundary Fee*/

    constructor(payload?: { [key: string]: any }) {
        Object.assign(this, payload);
    }

    public IsBoundaryFieldsFilled(): boolean {
        if (this.BoundaryFeeAmount && this.BoundaryProcessingFee && this.BoundaryAvailableDays.length !== 0 && this.CollectAtStart !== undefined) {
            return true;
        }
        return false;
    }

    public GetBoundaryEarning(): string {
        let earning = 0;
        if (this.BoundaryFeeAmount && this.BoundaryFeeAmount > this.BoundaryProcessingFee) {
            earning = this.BoundaryFeeAmount - this.BoundaryProcessingFee;
        }
        return earning.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    public IsOwnerFieldsFilled(): boolean {
        if (this.IsOwner) {
            return true;
        }
        return !!(this.OwnerFirstName && this.OwnerLastName && this.OwnerEmail && this.OwnerPhone);
    }

    public IsVehicleDetailsFieldsFilled(): boolean {
        if (this.VehicleTypeId && this.VehicleBrandId && this.VehicleModelId && this.VehicleYear
            && this.VehicleColor && this.NumberPlate && this.IsOwnerFieldsFilled()) {
            return true;
        }
        return false;
    }

    public IsVehiclePhotoFieldsFilled(): boolean {
        return !!(this.VehicleFrontImageUrl && this.VehicleBackImageUrl
            && this.VehicleRightSideImageUrl && this.VehicleLeftSideImageUrl);
    }

    public IsVehicleOwnershipFieldsFilled(): boolean {
        const hasOrCr = !!(this.LTOOfficialReceiptImageUrl && this.CertificateRegistrationImageUrl && this.LTOOfficialReceiptExpireAt);
        if (this.IsOwner) {
            return hasOrCr;
        }
        return hasOrCr && !!this.SPAImageUrl;
    }

    public IsTnvcFieldsFilled(): boolean {
        if (this.IsRegisteredTNC) {
            return true;
        }
        return !!(this.TNCType && this.PaOrCpcCaseNumber
            && this.ProvisionalAuthorityImageUrl && this.ProvisionalAuthorityExpireAt
            && this.CertificatePublicConvenienceImageUrl && this.CertificatePublicConvenienceExpireAt);
    }

    public IsRequiredFieldsFilled(): boolean {
        return this.IsVehicleDetailsFieldsFilled()
            && this.IsVehiclePhotoFieldsFilled()
            && this.IsVehicleOwnershipFieldsFilled()
            && this.IsTnvcFieldsFilled()
            && this.IsBoundaryFieldsFilled();
    }
}
